import { DependencyList, EffectCallback, useEffect } from "react";

function useMountEffect(effect: EffectCallback, deps: DependencyList = []) {
  return useEffect(effect, deps);
}

export default useMountEffect;
